<template>
  <TWModal
    :title="$t('teams.deleteTeam')"
    :loading="loading"
    :show="show"
    @close="close">
    <template v-slot:content>
      <p data-hj-suppress>{{ $t('teams.removeTeamWarning', { teamName: group.name }) }}</p>
    </template>
    <template v-slot:controls>
      <div class="flex w-full justify-between">
        <button
          type="button"
          id="group_delete_modal_cancel"
          class="tw-button"
          @click="close"
          data-ec="delete_group_modal"
          data-et="btn_cancel">
        <span>{{ $t('functional.cancel') }}</span>
        </button>
        <button
          type="button"
          id="group_delete_modal_delete"
          class="tw-button tw-button-error"
          @click="handleButtonDeleteClick"
          data-ec="delete_group_modal"
          data-et="btn_delete">
          <TrashIcon />
          <span>{{ $t('teams.deleteTeam')}}</span>
        </button>
      </div>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import { TrashIcon } from '@/components/icons/fontIcons';

export default {
  name: 'DeleteGroupModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    group: {
      type: [Object],
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    TWModal,
    TrashIcon,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    close() {
      this.$emit('onClose');
    },
    handleButtonDeleteClick() {
      this.loading = true;
      this.$store.dispatch('groups/DELETE', this.group).then(() => {
        this.$emit('onDeleted');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
